import { useState } from 'react';
import * as Styles from './LineClampTypography.styles';
import { LineClampTypographyProps } from './LineClampTypography.types';

const LineClampTypography = ({
  content,
  lines,
  disableFulltextToggle,
  typographyProps,
  fullTextToggleProps,
}: LineClampTypographyProps) => {
  const [showFullText, setShowFullText] = useState(false);

  const handleToggleClick = () => {
    setShowFullText((prev) => !prev);
  };

  return (
    <>
      <Styles.LineClampText
        lines={lines}
        showFullText={showFullText}
        {...typographyProps}
      >
        {content}
      </Styles.LineClampText>
      {!disableFulltextToggle && (
        <Styles.ToggleText
          fontWeight="fontWeightMedium"
          onClick={handleToggleClick}
          {...fullTextToggleProps}
        >
          {showFullText ? 'Show less' : 'Show more'}
        </Styles.ToggleText>
      )}
    </>
  );
};

export default LineClampTypography;
